import { createPageLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { SPACE_DIRECTORY_LOAD_KEY } from '@confluence/browser-metrics/entry-points/metric-keys.ts';

export const SPACE_DIRECTORY_PAGE_LOAD = createPageLoadMetric({
	key: SPACE_DIRECTORY_LOAD_KEY,
});
